import * as React from 'react'
import PageLayout from '@/components/ui/page-layout'
import UsersTable from '@/features/users/components/UsersTable'

export default function UsersPage() {
    return (
        <PageLayout
            title='Users'
            subtitle='Manage application users'
            breadcrumbs={[{ label: 'Users' }]}
        >
            <UsersTable />
        </PageLayout>
    )
}


